module.exports = __webpack_public_path__ + "img/betsection.f5d79dc4.webp";